export enum apiUrlClaimEvents {
    EVENT_CLAIM_REQUEST = '/v1/event-claim-request/',
}
